<div class="db-cdn">

  <db-cdn-notice [websiteId]="website?.id"></db-cdn-notice>
  <div class="db-cdn-components">
    <!--<db-loading-screen [ngClass]="{'hidden':!(cdnDataLoading$ | async) && !!website?.cloudflareEnabled}" [pageBlocker]="true"></db-loading-screen>-->
    <db-cdn-disabled *ngIf="!website?.cloudflareEnabled"
                     [user]="user"
                     [website]="website"
                     [currentSubscription]="currentSubscription" [isNameServer]="isNameServer"
                     [hasCertificate]="hasCertificate" [serverIp]="serverIp"
                     [enabledCdnCount]="enabledCdnCount?.length" [currentWorkspace]="currentWorkspace"></db-cdn-disabled>
    <db-cdn-pending *ngIf="website?.cloudflareEnabled && isStatusPending && !isNameServer"
                    [server]="server"></db-cdn-pending>
    <ds-tabs *ngIf="website?.cloudflareEnabled && (!isStatusPending || (isStatusPending && !!this.isNameServer))"
             [activeTabId]="activeTab"
             (onActiveTabChange)="setActiveTab($event.tabId)">
      <ds-tab-head *ngFor="let tab of tabs" [tabId]="tab?.id" [activeTabId]="activeTab">
        <span class="ds-account__sidebar-link" [innerHTML]="tab.label"></span>
      </ds-tab-head>
      <ds-tab-content [tabId]="activeTab" [activeTabId]="activeTab">
        <db-cdn-overview *ngIf="activeTab === 'overview'" [isNameServer]="isNameServer"></db-cdn-overview>
        <db-cdn-full-page-cache *ngIf="activeTab === 'full-page'"></db-cdn-full-page-cache>
        <db-cdn-settings *ngIf="activeTab === 'settings'" [hasDcvRecord]="hasDcvRecord"
                         [currentWorkspace]="currentWorkspace"
                         [isNameServer]="isNameServer"></db-cdn-settings>
      </ds-tab-content>
    </ds-tabs>
  </div>
</div>
